import React from 'react';
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import About from './about';
import Announcements from './announcements';
import styled from 'styled-components';
import Productcorousal from './productcorousal';
import Productdownload from './productdownload';
import Deliverycorousal from './deliverycorousal';
import DeliveryProductDownload from './deliveryappdownload';
import '../App.css';


const OurProducts=styled.div`
    padding: 2%;
    font-family: 'Merriweather', serif;
    margin:4% 1%;
    
`;



const AboutAnnounce=styled.div`
/* display: flex; */
margin:2% 1% 1% 1%;

padding: 0%;

background-color: white;
`;




const Home=()=> {
  return (
    <div>
      
      <Container>
      <AboutAnnounce>
      <Row >
      <Col>
      <About></About>
      </Col>
      </Row>
      </AboutAnnounce>
      </Container>

      

      
    </div>
  );
}

export default Home;
